import { groupBy, sortBy } from 'lodash';

import { getLanguageCode } from 'js/lib/language';

import type { PartnerSpecializationFragment } from 'bundles/partners-graphql/components/cds/queries/__generated__/PartnerSpecializationsQuery';

function getSpecializationLanguage(s12n: PartnerSpecializationFragment): string {
  return s12n.courses?.[0]?.primaryLanguageCodes?.[0] || 'en';
}

export function sortAndFilterSpecializations(
  specializations: PartnerSpecializationFragment[]
): PartnerSpecializationFragment[] {
  // 1. Filter: only keep launched or has planned launch date
  const filtered = specializations.filter((s12n) => !!s12n.launchedAt || !!s12n.plannedLaunchDate);

  // 2. Deduplicate by ID
  const unique = filtered.filter((s12n, index, arr) => arr.findIndex((s) => s.id === s12n.id) === index);

  // 3. Alphabetical sort by name
  const sorted = sortBy(unique, (s12n) => s12n.name);

  // 4. Language boost: group by first course's first language,
  //    user-language group first, then others sorted by group size (descending)
  const grouped = groupBy(sorted, getSpecializationLanguage);
  const userLocale = getLanguageCode();
  const userLocaleS12ns = grouped[userLocale] || [];
  const otherGroups = sortBy(
    Object.entries(grouped).filter(([lang]) => lang !== userLocale),
    ([, items]) => -items.length
  );

  return [...userLocaleS12ns, ...otherGroups.flatMap(([, items]) => items)];
}
